import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        dialogList: [],
        messageList: {
            items: []
        },
        contactsList: {},
        user: {}
    },
    getters: {
        dialogList(state){
            return state.dialogList;
        },
        contactsList(state){
            return state.contactsList;
        },
        user(state){
            return state.user;
        },
        contactsListToAdd(state){
            let arr = [];
            for (const id in state.contactsList) {
                if (state.contactsList.hasOwnProperty(id) && (state.contactsList[id].newUser) && (state.contactsList[id].checked)) {
                    arr.push(id);
                }
            }
            return arr;
        },
        contactsListToRemove(state){
            let arr = [];
            for (const id in state.contactsList) {
                if (state.contactsList.hasOwnProperty(id) && (!state.contactsList[id].newUser) && (!state.contactsList[id].checked)) {
                    arr.push(id);
                }
            }
            return arr;
        },
        messageList(state){
            return state.messageList;
        },
        itemsMap(state){
            let itemsMap = {};

            for(let i = 0; i < state.dialogList.length; i++){
                let dialog = state.dialogList[i];
                itemsMap[dialog.id] = dialog;
            }

            return itemsMap;
        },
        activeDialog: (state, getters) => (id) => {
            return getters.itemsMap[id];
        }
    },
    mutations: {
        SetDialogList(state, data){
            state.dialogList = data;
        },
        OpenDialog(state, id){
            state.dialogList.some((item)=>{
                if (item.id == id){
                    item.new = false
                    // let obj = {}
                    // obj.new = false
                    // item = Object.assign({}, item, obj)

                    // console.log(item);

                    return false
                } else 
                    return true
            })
        },
        SetMessageList(state, data){
            state.messageList = data;
        },
        SetFromLoadContactsList(state, data){
            // перезаписывание списка участинов диалога 
            let obj = {};
            data.forEach(item => {
                item.checked = true;
                item.newUser = false;
                obj[item.id] = item;
            })
            state.contactsList = obj;
        },
        AddNewContactsList(state, data){
            if (state.contactsList.hasOwnProperty(data.id)) {
                data.newUser = false;
            } else {
                data.newUser = true;
            }
            let obj = {}
            obj[data.id] = data;
            state.contactsList = Object.assign({}, state.contactsList, obj);
        },
        SeItemContactsList(state, data){
            let obj = {}
            obj[data.id] = data;
            state.contactsList = Object.assign({}, state.contactsList, obj);
        },
        SetUser(state, data){
            state.user = data;
        }
    },
    actions: {
        LoadDialogList ({commit}){
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/dialogList.json' : 'dialog';

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetDialogList' ,data);
                        resolve();
                    })
            })
        },
        OpenDialog({commit}, id){
            commit('OpenDialog', id);
        },
        LoadMessageList ({commit}, data){
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/messageList.json' : 'dialog/' + data;

            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetMessageList' ,data);
                        resolve();
                    })
            })
        },
        LoadContactsList ({commit}, id) {

            // получить текущих участников в диалога по id диалога
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/dialogUsers.json' : 'dialog/users';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params:{sel: id}})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetFromLoadContactsList', data);
                        resolve();
                    })
            })
        },
        AddNewContactsList({commit}, userUrl){
            // добавить участника в диалог по урл
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/dialogUser.json' : 'dialog/user';

            return new Promise((resolve, reject) => {
                Vue.http.get(url, { params: { url: userUrl } })
                    .then(response => response.json())
                    .then(
                        data => {
                            let newItem = data;
                            newItem.checked = true;
                            commit('AddNewContactsList', data);
                            resolve();
                        },
                        ()=>{
                            reject();
                        }
                    )})
        },
        AddDialogContactsList({commit, state}){
            // добавить участника в диалог из списка контактов
            return new Promise((resolve, reject) => {
                commit('SetFromLoadContactsList', []);
                state.dialogList.forEach((item)=>{
                    if(item.usersCount == 1 && !item.isAdmin){
                        let newItem = {};
                        newItem.checked = false;
                        newItem.newUser = true;
                        newItem.id = item.userId;
                        newItem.name = item.name;
                        newItem.img = item.img;
                        newItem.url = item.url;
                        newItem.online = item.online;
                        commit('AddNewContactsList', newItem);
                    }
                });
                resolve();
            })
        },
        
        ChangeDialogContactsList({commit}, newVal){
            //  изменить или добавить участника в диалог
            commit('SeItemContactsList', newVal);
        },
        LoadUser ({commit}){
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/dialogUserSelf.json' : 'dialog/user';
            return new Promise((resolve, reject) => {
                Vue.http.get(url)
                    .then(response => response.json())
                    .then(data => {
                        commit('SetUser' ,data);
                        resolve();
                    })
            })
        },
        GetUserSel({commit}, data){
            // получить номер диалога( если нет то создать диалог и вернуть id диалога )
            let url = process.env.NODE_ENV !== 'production' ? 'dialog/userSel.json' : 'dialog';
            return new Promise((resolve, reject) => {
                Vue.http.get(url, {params: {userId: data}})
                    .then(response => response.json())
                    .then(data => {
                        resolve(data);
                    })
            })
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/dialog.js